/**
 * Security utilities for the application
 */

// HTML escaping to prevent XSS in dynamic content injection
const HTML_ESCAPE_MAP = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '/': '&#x2F;'
};

export const escapeHtml = (str) => {
  if (str === null || str === undefined) return '';
  return String(str).replace(/[&<>"'/]/g, (match) => HTML_ESCAPE_MAP[match]);
};

// Secure session-scoped storage wrapper (sessionStorage clears on tab/browser close)
const STORAGE_PREFIX = 'nc_';

export const secureStorage = {
  set(key, value) {
    try {
      sessionStorage.setItem(`${STORAGE_PREFIX}${key}`, btoa(encodeURIComponent(value)));
    } catch {
      // Storage full or unavailable
    }
  },
  get(key) {
    try {
      const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${key}`);
      if (!raw) return null;
      return decodeURIComponent(atob(raw));
    } catch {
      return null;
    }
  },
  remove(key) {
    sessionStorage.removeItem(`${STORAGE_PREFIX}${key}`);
  },
  clear() {
    Object.keys(sessionStorage)
      .filter(k => k.startsWith(STORAGE_PREFIX))
      .forEach(k => sessionStorage.removeItem(k));
  }
};

// Migrate from old localStorage to new sessionStorage on first load
export const migrateFromLocalStorage = () => {
  const oldKeys = [
    'admin_token', 'admin_username', 'admin_store_id', 'admin_store_name',
    'admin_store_domain', 'admin_role', 'admin_path', 'superadmin_token'
  ];
  oldKeys.forEach(key => {
    const val = localStorage.getItem(key);
    if (val) {
      secureStorage.set(key, val);
      localStorage.removeItem(key);
    }
  });
};
